import enumify from './enumify';

export const TOTALS = 'totals';
export const VERIFIED = 'verified';

export default enumify({ TOTALS, VERIFIED });
